import { PluginKey } from 'prosemirror-state';
import { ContentNodeWithPos } from 'prosemirror-utils';

import { EditorView } from '@lyearn/lygo-core';

export const setPlaceholder = (
  editorView: EditorView,
  nodeName: string,
  getplaceholderString: (contentNode: ContentNodeWithPos) => string,
) => {
  if (!editorView.editable) {
    return;
  }
  const placeholders = placeholderPluginKey.getState(editorView.state)?.placeholders;

  if (placeholders) {
    const newState = { placeholders: placeholders.set(nodeName, getplaceholderString) };

    editorView.dispatch(editorView.state.tr.setMeta(placeholderPluginKey, newState));
  }
};

export const placeholderPluginKey = new PluginKey('placeholder-plugin');
